module.exports = __webpack_public_path__ + "static/media/waveum_main_logo.86dad8c5.png";